import React from 'react';

import {useRouteMatch} from "react-router-dom";

import Kairogramm from './Kairogramm.js';


/*
Wraps a kairogramm with routing
 */
const RoutingKairogramm = ({
	client,
	print,
}) => {
	const match = useRouteMatch();

	const clientId = client.id;
	const kairogrammId = match.params.kairogrammId;
	const kairogramm = client.kairogramme.find(k => k.id === kairogrammId);
	const baseUrl = `/api/clients/${clientId}/kairogramm/${kairogrammId}`;

	// render

	return (
		<Kairogramm
			client = {client}
			kairogramm = {kairogramm}
			baseUrl = {baseUrl}
			onPrint = {ev => window.open(`/print-kairogramm/${clientId}/kairogramm/${kairogrammId}`)}
			print = {print}/>
	);
};

export default RoutingKairogramm;
